<div class="flex items-center gap-x-2">
  @if (isCompleted()) {
    <parkour-icon class="text-positive flex" name="check" size="3" />
    <span class="typo-body text-n-600">{{ 'doelen.doelen-page.completed-doel' | translate }}</span>
  } @else {
    @if (getTotalAmountOfAction() > 0) {
      <parkour-doel-progress-circle
        [currentValue]="getAmountOfCompletedAction()"
        [maxValue]="getTotalAmountOfAction()"
      ></parkour-doel-progress-circle>
      @if (getTotalAmountOfAction() > 1 || getTotalAmountOfAction() === 0) {
        <span class="typo-body text-n-700">
          {{ getTotalAmountOfAction() }}{{ 'doelen.doelen-page.acties' | translate }}
        </span>
      } @else {
        <span class="typo-body text-n-700">
          {{ getTotalAmountOfAction() }}{{ 'doelen.doelen-page.actie' | translate }}
        </span>
      }
    }
  }
</div>
